import type { ILinkItem } from '@belong/types';
import { FLinkListItem } from './moleculeLinkListItem.factory';

export const FLinkList = (data: any): ILinkItem[] => {
  return data.fields.items.map(FLinkListItem);
};
